import React, { Component } from "react";
import { getCDNUrl, convertUnicode } from "../commons/CommonFunctions";
import dateUtil from "date-and-time";
import * as _ from "lodash";
import { NavLink } from "react-router-dom";
export default class UnAuthRightPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      projectValue: {
        startDate: "",
        endDate: "",
        title: "",
        status: "",
        shortBrief: "",
        noOfParticipants: 0,
        noOfResearches: 0,
        feedbackCount: 0,
        companyName: "",
        location: {},
        creatorUserId: "",
        followed: false,
        imageUrl: "",
        creatorBannerImage: "",
        customUrl: "",
        partyType: "",
        params: [],
      },
    };
  }

  getNoOfResearches = () => {
    let researchDiv = (
      <li>
        <i className="iAddResearch_fl"></i>
        {this.state.projectValue.noOfResearches} Researches
      </li>
    );

    if (
      this.state.projectValue.noOfResearches &&
      this.state.projectValue.noOfResearches > 0
    ) {
      return researchDiv;
    } else {
      return undefined;
    }
  };

  getFeedback = () => {
    let feedbackDiv = (
      <div className="projdtlsfeedsrating">
        <i className="iStar staractive"></i>
        <i className="iStar staractive"></i>
        <i className="iStar staractive"></i>
        <i className="iStar staractive"></i>
        <i className="iStar"></i>
        <span>{this.state.projectValue.feedbackCount} Feedbacks</span>
      </div>
    );

    if (
      this.state.projectValue.feedbackCount &&
      this.state.projectValue.feedbackCount > 0
    ) {
      return feedbackDiv;
    } else {
      return undefined;
    }
  };

  componentDidMount() {
    if (this.props.projectDetail && this.props.projectDetail.project) {
      let participationDetails = this.props.projectDetail?.participationDetails;
      let project = this.props.projectDetail?.project;
      let startDate = "";
      let endDate = "NA";
      let creatorBannerImage = this.props.projectDetail?.creatorBannerImage;
      let customUrl = this.props.projectDetail?.customUrl;
      let partyType = this.props.projectDetail?.partyType;
      let params = this.props.projectDetail?.params;
      let stageValue = "Completed";
      let imageUrl = this.props.projectDetail?.imageUrl;

      let proj = this.props.projectDetail?.project;
      let title = proj?.title;
      let stage = this.props.projectDetail?.stage;

      startDate = dateUtil.format(
        new Date(this.props.projectDetail?.startDate),
        "DD MMM YYYY"
      );
      if (project.endingTime > 0) {
        endDate = dateUtil.format(new Date(project?.endingTime), "DD MMM YYYY");
      }
      stageValue = stage.charAt(0).toUpperCase() + stage.slice(1);

      let participationCount = participationDetails.participationCount;
      let noOfParticipant = participationDetails.noOfParticipant;
      let shortBrief = project.shortBrief;
      let creatorUserId = project.userId;
      let followed = this.props.projectDetail.followed;
      let location = project.location;
      let postedBy = participationDetails.postedBy;

      this.setState({
        projectValue: {
          ...this.state.projectValue,
          startDate,
          endDate,
          title,
          status: stageValue,
          noOfParticipants: noOfParticipant || participationCount,
          shortBrief,
          location,
          creatorUserId,
          followed,
          companyName: postedBy,
          imageUrl,
          creatorBannerImage,
          customUrl,
          partyType,
          params,
        },
      });
    }
  }
  render() {
    return (
      <div className="col-lg-3" style={{ paddingTop: "15px" }}>
        <div className="projdtlsfeedswidget">
          <div
            className="imgbox"
            onClick={(e) => {
              e.preventDefault();
            }}
            style={{ cursor: "pointer" }}
          >
            <img
              src={
                this.state.projectValue &&
                this.state.projectValue.creatorBannerImage
                  ? getCDNUrl(this.state.projectValue.creatorBannerImage)
                  : !_.isUndefined(this.state.projectValue.creatorBannerImage)
                  ? "https://cdn.dscovr.com/images/prof-banner.png"
                  : null
              }
              alt=""
            />
          </div>

          <h3>Posted by</h3>
          <div className="companyname">
            <div className="projhead">
              <figure
                className="complogo"
                onClick={(e) => {
                  e.preventDefault();
                }}
                style={{ cursor: "pointer" }}
              >
                <img
                  src={
                    this.state.projectValue && this.state.projectValue.imageUrl
                      ? getCDNUrl(this.state.projectValue.imageUrl)
                      : this.state.projectValue.partyType == "CIRCLE"
                      ? "https://cdn.dscovr.com/images/circleDefault.webp"
                      : this.props.projectDetail.userType == "INDIVIDUAL"
                      ? "https://cdn.dscovr.com/images/users1.png"
                      : "https://cdn.dscovr.com/images/DefaultBusiness.png"
                  }
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src =
                      "https://cdn.dscovr.com/images/circleDefault.png";
                  }}
                  alt=""
                />
              </figure>
              <div>
                <a
                  onClick={(e) => {
                    e.preventDefault();
                  }}
                >
                  <h5>
                    {this.state.projectValue &&
                      this.state.projectValue.companyName}
                  </h5>
                </a>

                {this.state.projectValue &&
                  this.state.projectValue.location &&
                  this.state.projectValue.location.city && (
                    <span className="address">
                      {this.state.projectValue.location.city +
                        ", " +
                        this.state.projectValue.location.state +
                        ", " +
                        this.state.projectValue.location.country}
                    </span>
                  )}
              </div>
            </div>
          </div>
        </div>

        <div className="projdtlsfeedswidget">
          <div className="projdtlsfeedswidgetdesc">
            {/*<ProjectDetails projectType={this.props.project && this.props.project.participationDetails && this.props.project.participationDetails.secondaryEntityType}/>*/}
            <h4>
              <a
                href="javascript:void(0)"
                onClick={(e) =>
                  this.setProjectDetails(this.props.projectDetail)
                }
                //data-toggle="modal"
              >
                {convertUnicode(
                  this.state.projectValue &&
                    this.state.projectValue.title &&
                    this.state.projectValue.title
                )}
              </a>
            </h4>
            <p>
              {this.state.projectValue &&
                this.state.projectValue.shortBrief.split("\\n").map((brief) => (
                  <>
                    {convertUnicode(brief)}
                    <br />
                  </>
                ))}
            </p>
          </div>

          <ul>
            {this.state.projectValue &&
              this.state.projectValue.noOfParticipants &&
              this.state.projectValue.noOfParticipants > 0 &&
              (this.props.projectDetail &&
              this.props.projectDetail.participationDetails &&
              this.props.projectDetail.participationDetails
                .secondaryEntityType &&
              this.props.projectDetail.participationDetails
                .secondaryEntityType === "FUNDRAISE" ? (
                <li>
                  <i className="iParticipants"></i>{" "}
                  {this.state.projectValue.noOfParticipants}{" "}
                  {this.state.projectValue.noOfParticipants < 2
                    ? "Contributor"
                    : "Contributors"}
                </li>
              ) : (
                <li>
                  <i className="iParticipants"></i>{" "}
                  {this.state.projectValue.noOfParticipants}{" "}
                  {this.state.projectValue.noOfParticipants < 2
                    ? "Applicant"
                    : "Applicants"}
                </li>
              ))}

            {this.getNoOfResearches()}
          </ul>
          {this.getFeedback()}

          <div className="pdfeedsdate">
            <div>
              Start Date
              <span>
                {this.state.projectValue && this.state.projectValue.startDate}
              </span>
            </div>
            <div>
              End Date
              <span>
                {this.state.projectValue && this.state.projectValue.endDate}
              </span>
            </div>
          </div>
          <div className="pdfeedssstaatus">
            {this.state.projectValue && this.state.projectValue.status}
          </div>
        </div>

        <div className="projdtlsfeedswidgetbott links">
          <NavLink exact to="/PrivacyPolicy">
            Privacy Policy
          </NavLink>{" "}
          <span>|</span>
          <NavLink exact to="/TermsConditions">
            Terms & Conditions
          </NavLink>{" "}
          <span>|</span>
          {/*<NavLink exact to="/UserAgreement">User Agreement</NavLink>*/}
          <NavLink exact to="/CookiePolicy">
            Cookie Policy
          </NavLink>
        </div>

        <div className="projdtlsfeedswidgetbott">
          All Rights Reserved. <br />
          2019 © Dscovr Journeys
        </div>
      </div>
    );
  }
}
